import PaymentDetails from "./PaymentDetails";
export default PaymentDetails;
